// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/api/topups/card_payments/firstparty/v4/get_payment_details.proto

/* oxlint-disable */
import { ApiCurrencyAmount } from "../../../../../../common/payment";

/** Request to retrieve payment details for a Checkout.com payment session. */
export interface ApiGetPaymentDetailsRequest {
  /** Checkout.com session ID, retrieved from the redirect URL after payment completion. */
  readonly ckoSessionId: string;
}

/** Response containing payment details for a completed Checkout.com payment session. */
export interface ApiGetPaymentDetailsResponse {
  /** Amount of the payment. */
  readonly amount: ApiCurrencyAmount | null;
}

export const ApiGetPaymentDetailsRequest: MessageFns<ApiGetPaymentDetailsRequest> = {
  fromJSON(object: any): ApiGetPaymentDetailsRequest {
    return { ckoSessionId: isSet(object.cko_session_id) ? globalThis.String(object.cko_session_id) : "" };
  },

  toJSON(message: ApiGetPaymentDetailsRequest): unknown {
    const obj: any = {};
    if (message.ckoSessionId !== undefined && message.ckoSessionId !== null) {
      obj.cko_session_id = message.ckoSessionId;
    }
    return obj;
  },
};

export const ApiGetPaymentDetailsResponse: MessageFns<ApiGetPaymentDetailsResponse> = {
  fromJSON(object: any): ApiGetPaymentDetailsResponse {
    return { amount: isSet(object.amount) ? ApiCurrencyAmount.fromJSON(object.amount) : null };
  },

  toJSON(message: ApiGetPaymentDetailsResponse): unknown {
    const obj: any = {};
    if (message.amount !== undefined && message.amount !== null) {
      obj.amount = ApiCurrencyAmount.toJSON(message.amount);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
